import { render, staticRenderFns } from "./SalesProcessForms.vue?vue&type=template&id=506ada2e&scoped=true"
import script from "./SalesProcessForms.vue?vue&type=script&lang=ts"
export * from "./SalesProcessForms.vue?vue&type=script&lang=ts"
import style0 from "./SalesProcessForms.vue?vue&type=style&index=0&id=506ada2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ada2e",
  null
  
)

export default component.exports